import { useMap } from 'react-map-gl';

export const useMapboxMapContext = () => {
  const context = useMap();
  if (!context)
    throw new Error('No Mapbox map context found. Is there a wrapping Mapbox map component?');
  return context;
};
